module.exports = __webpack_public_path__ + "img/precious.ab784355.jpeg";